var map = {
	"./bar-img-unavailable.png": "e149",
	"./blue-badge.png": "db49",
	"./jeet11-rummy.png": "fede",
	"./jeet11.png": "3173",
	"./logo.png": "cf05",
	"./orange-badge.png": "bcaa",
	"./title-logo.png": "ba0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";